import "./WhatWeDo.css";
import illustration1 from "../../assests/illustration1.svg";
const WhatWeDo = () => {
 return (
  <section className="whatwedo" id="whatwedo">
   <h2 className="title">What We Do</h2>
   <div className="container max-width">
    <div className="left-content">
     <p>Let's Connect</p>
     <p>Getting You Connected To Your Audience</p>
    </div>

    <div className="right-content">
     <p className="semi-bold">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim maiores nisi
      alias architecto, iusto vitae officiis corporis reiciendis id molestiae
      nihil sint similique aliquam a dolorum, temporibus assumenda? Nobis, eum?
      Cum laudantium sunt dicta adipisci atque ipsum ipsam tempora culpa
      doloribus, animi totam sed ipsa facere, molestiae perferendis quaerat
      odio!
     </p>
     <p className="semi-bold">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim maiores nisi
      alias architecto, iusto vitae officiis corporis reiciendis id molestiae
      nihil sint similique aliquam a dolorum, temporibus assumenda? Nobis, eum?
      Cum laudantium sunt dicta adipisci atque ipsum ipsam tempora culpa
      doloribus, animi totam sed ipsa facere, molestiae perferendis quaerat
      odio!
     </p>
     <p className="semi-bold">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim maiores nisi
      alias architecto, iusto vitae officiis corporis reiciendis id molestiae
      nihil sint similique aliquam a dolorum, temporibus assumenda? Nobis, eum?
      Cum laudantium sunt dicta adipisci atque ipsum ipsam tempora culpa
      doloribus, animi totam sed ipsa facere, molestiae perferendis quaerat
      odio!
     </p>
    </div>
   </div>

   <div className="image-container">
    <img src={illustration1} alt="what we do" />
   </div>
  </section>
 );
};

export default WhatWeDo;
